/**
 * Detect mobile in-app WebView environments whose IndexedDB / long-running
 * session behaviour is too unreliable for Reader to function.
 *
 * Confirmed problematic:
 *   - WeChat (MicroMessenger): IDB quota ≤5MB, transactions get torn down on
 *     memory pressure / tab background, persistence not guaranteed. User
 *     c2df1784… (shejiwushi@qq.com, 2026-04-22) hit 7 `in-progress transaction`
 *     failures in 11 minutes before giving up.
 *   - QQ (QQ/): same WebView family, same issues.
 *   - Weibo (Weibo): observed similar IDB instability.
 *
 * Desktop browsers and standalone mobile browsers (Safari, Chrome, Firefox,
 * Edge, etc.) are NOT blocked even if their UA strings resemble a subset of
 * an in-app browser — we only gate on the in-app-browser-specific tokens.
 *
 * @param {string} [ua]  override for tests; defaults to navigator.userAgent
 * @returns {{ isInApp: boolean, name: string | null }}
 */
export function detectInAppBrowser(ua) {
  const userAgent = typeof ua === 'string'
    ? ua
    : (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '';
  if (!userAgent) return { isInApp: false, name: null };

  // Matchers are UA substrings known to uniquely identify the in-app
  // WebView. Order doesn't matter — first hit wins for reporting only.
  const matchers = [
    { name: 'WeChat', pattern: /MicroMessenger/i },
    { name: 'QQ',     pattern: /\bQQ\/\d/i },        // official QQ app (avoids generic "QQBrowser")
    { name: 'Weibo',  pattern: /Weibo/i },
    { name: 'DingTalk', pattern: /DingTalk/i },
  ];

  for (const m of matchers) {
    if (m.pattern.test(userAgent)) return { isInApp: true, name: m.name };
  }
  return { isInApp: false, name: null };
}
